module.exports = __webpack_public_path__ + "static/media/jeanFrancoisBelis.fbc0795c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/jeanFrancoisBelis.jpg
// module id = 1568
// module chunks = 1